import React from 'react';
import { Reveal, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const Stats = () => {
  const { t } = useLanguage();
  return (
    <section
      id="stats"
      data-testid={SITE.sectionStats}
      className="relative py-20 lg:py-28 bg-[#0B0F0C] text-white overflow-hidden"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(34,197,94,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(34,197,94,0.6) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-40 -left-32 w-[500px] h-[500px] rounded-full blur-3xl"
        style={{ background: 'radial-gradient(circle, rgba(0,166,81,0.22) 0%, transparent 60%)' }}
      />

      <Container>
        <Reveal>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white max-w-3xl">
            {t.stats.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {t.stats.items.map((s, i) => (
            <Reveal key={s.value} delay={i * 0.08}>
              <div className="border-t border-white/10 pt-6">
                <div className="font-['Outfit'] text-4xl sm:text-5xl lg:text-6xl font-bold text-[#22C55E] tracking-tight">
                  {s.value}
                </div>
                <div className="mt-3 text-sm text-white/70 leading-snug max-w-[14rem]">
                  {s.label}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="mt-12 text-xs sm:text-sm text-white/45 tracking-wide">
            {t.stats.footnote}
          </p>
        </Reveal>
      </Container>
    </section>
  );
};

export default Stats;
